export default __webpack_public_path__ + "static/media/backArrow.9dc53065.svg";